import React from "react";

const Card = ({ children }) => {
    return (
        <div className="flex flex-col bg-white bg-opacity-10 items-center p-4 rounded-lg shadow-md w-full max-w-4xl mx-auto">
            {children}
        </div>
    );
}

export default Card;